import type { PlacementConfig, Pose } from "./types";
import { quatFromAxisAngle } from "./math";

const DEG2RAD = Math.PI / 180;
const IDENTITY = { x: 0, y: 0, z: 0, w: 1 };

/**
 * Resolve a floor-elevated placement to a world-space pose for the signage.
 * The user sits at the origin; the sign is placed along the heading (azimuth, 0 = −Z = north)
 * at `distance` metres, raised `height` metres on Y. With `faceUser`, the sign yaws to point
 * its forward (−Z) back at the origin.
 */
export function computePlacement(config: PlacementConfig): Pose {
  const heading = (config.azimuth ?? 0) * DEG2RAD;
  const position = {
    x: Math.sin(heading) * config.distance,
    y: config.height,
    z: -Math.cos(heading) * config.distance,
  };

  const orientation = config.faceUser
    ? quatFromAxisAngle({ x: 0, y: 1, z: 0 }, Math.atan2(position.x, position.z))
    : { ...IDENTITY };

  return { position, orientation };
}
